import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({
  imports: [CommonModule],
})
export class IconsModule {
  basePath = 'assets';

  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
    this.addIcon('check-circle', '/check-circle.svg');
    this.addIcon('check-circle-outline', '/check-circle-outline.svg');
    this.addIcon('arrow-forward', '/arrow-forward.svg');
    this.addIcon('arrow-back', '/arrow-back.svg');
    this.addIcon('warning', '/warning.svg');
  }

  addIcon(iconName: string, relativePath: string) {
    this.iconRegistry.addSvgIcon(
      iconName,
      this.sanitizer.bypassSecurityTrustResourceUrl(this.basePath + relativePath)
    );
  }
}
